import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
export class OrderByService {

    private static compareNumber(obj1, obj2): number {
        return obj1 === obj2 ? 0 : (obj1 > obj2 ? 1 : -1)
    }

    orderBy<T>(obj: T[], orderFields: string[], sortDesc: boolean): T[] {
        const sgn = sortDesc ? -1 : 1

        obj.sort((obj1, obj2): number => {
            let order = 0

            for (let i = 0; i < orderFields.length; i++) {
                order = this.order(obj1, obj2, orderFields[i], sgn)

                if (order !== 0) {
                    break
                }
            }

            return order
        })

        return obj
    }

    private order<T>(obj1: T, obj2: T, prop, sgn): number {
        const o1 = this.byString(obj1, prop)
        const o2 = this.byString(obj2, prop)

        if (typeof o1 === 'string') {
            return sgn * o1.localeCompare(o2, 'cs-CZ')
        } else if (typeof o1 === 'number') {
            return sgn * OrderByService.compareNumber(o1, o2)
        }

        return 0
    }

    private byString(o, s): any {
        s = s.replace(/\[(\w+)\]/g, '.$1') // convert indexes to properties
        s = s.replace(/^\./, '')           // strip a leading dot
        var a = s.split('.')
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i]
            if (k in o) {
                o = o[k]
            } else {
                return
            }
        }
        return o
    }
}